import Api from "../ApiUtility/Api";


class RequestSentDetailsDS {
  constructor() {
    this.api = new Api();
  }

  //LOGIN POST

  AP_SentRequests_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_SentRequests_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }


  WS_Inbound_Calls_Agencies_Get(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Inbound_Calls_Agencies_Get')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  AC_Incoming_Call_Info_ADD(requestData) {
    return this.api.postAPI(requestData, '/dev/AC_Incoming_Call_Info_ADD')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  AC_Call_Info_ADD(requestData) {
    return this.api.postAPI(requestData, '/dev/AC_Call_Info_ADD')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }


  AC_Call_Info_By_VIN_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/AC_Call_Info_By_VIN_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  AC_Incoming_Call_history_Get(requestData) {
    return this.api.postAPI(requestData, '/dev/AC_Incoming_Call_history_Get')
      .then(data => {
        console.log("Incoming call history", data)
        return data;
      })
      .catch(error => {
        console.error('Error during incoming call history API call :', error);
        throw error;
      });
  }

  WS_Agency_ByDatasetID_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_ByDatasetID_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_SentPdfData_ByID_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_SentPdfData_ByID_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_OutgoingRequest_Notes_ByID_UPDATE(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OutgoingRequest_Notes_ByID_UPDATE')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_Agency_Details_Get(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_Details_Get')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_OutgoingRequest_Status_ByID_UPDATE(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OutgoingRequest_Status_ByID_UPDATE')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_Agency_Details_Add_Data(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_Details_Add_Data')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  WS_OutgoingRequest_Cheque_Generate(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OutgoingRequest_Cheque_Generate')
      .then(data => {
        console.log("Cheque generation response", data);
        return data;
      })
      .catch(error => {
        console.error('Error during Cheque Generation API call :', error);
        throw error;
      });
  }
  WS_OutgoingRequest_Cheque_PresignedUrl_GET(requestData) {
    return this.api.postAPI(
      requestData, '/dev/WS_OutgoingRequest_Cheque_PresignedUrl_GET'
    )
      .then(data => {
        console.log("Cheque presigned URL response", data);
        return data;
      })
      .catch(error => {
        console.error(
          'Error during Cheque Presigned URL API call :', error);
        throw error;
      });
  }
  WS_Agency_Address_ById_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_Address_ById_GET')
      .then(data => {
        console.log("Agency address response", data);
        return data;
      })
      .catch(error => {
        console.error('Error during Agency Address API call :', error);
        throw error;
      });
  }
  WS_OutgoingRequest_Details_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OutgoingRequest_Details_GET')
      .then(data => {
        console.log("OutgoingRequest Details response", data);
        return data;
      })
      .catch(error => {
        console.error('Error during OutgoingRequest Details API call :', error);
        throw error;
      });
  }
  WS_OutgoingRequest_Event_ByID_UPDATE(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OutgoingRequest_Event_ByID_UPDATE')
      .then(data => {
        console.log("Event added response", data);
        return data;
      })
      .catch(error => {
        console.error('Error during Event Add API call :', error);
        throw error;
      });
  }

  WS_Agency_Ticket_History_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_Ticket_History_GET')
      .then(data => {
        console.log("Ticket history get", data);
        return data;
      })
      .catch(error => {
        console.error('Error during Ticket_History Get API call :', error);
        throw error;
      });
  }


  AC_Mail_Info_By_VIN_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/AC_Mail_Info_By_VIN_GET')
      .then(data => {
        console.log("Mail History", data);
        return data;
      })
      .catch(error => {
        console.error('Error during mail history API call :', error);
        throw error;
      });
  }


  WS_Email_Send_Schedule_History(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Email_Send_Schedule_History')
      .then(data => {
        console.log("Email Send", data);
        return data;
      })
      .catch(error => {
        console.error('Error during sending Email API call :', error);
        throw error;
      });
  }


}

export default RequestSentDetailsDS;